var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPieSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1942 25.3125V1.75078C32.1942 0.801563 32.9355 0 33.8887 0C46.9888 0 57.6109 10.5785 57.6109 23.625C57.6109 24.5742 56.806 25.3125 55.8529 25.3125H32.1942ZM3.38867 28.6875C3.38867 15.8941 12.9305 5.30508 25.3105 3.61758C26.2849 3.48047 27.1109 4.26094 27.1109 5.2418V30.375L43.6847 46.8809C44.3942 47.5875 44.3413 48.7477 43.5258 49.3172C39.3744 52.2703 34.2911 54 28.8053 54C14.7732 54 3.38867 42.6727 3.38867 28.6875ZM59.1359 30.375C60.1208 30.375 60.8939 31.1977 60.7668 32.168C59.9513 38.0637 57.1026 43.3055 52.9406 47.1762C52.3052 47.7668 51.3097 47.7246 50.6954 47.1023L33.8887 30.375H59.1359Z",
    fill: "#91BF82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieSolid);
export default __webpack_public_path__ + "static/media/chart-pie-solid.9b8ece8cce383d71b8f4933e35e7277d.svg";
export { ForwardRef as ReactComponent };